import axiosInstance from "../../config/axiosInstance";

const dashboardContractsToExpireRequest = async () => {
    return await axiosInstance.dillApi().get("operations/dashboard/all");
};

export default dashboardContractsToExpireRequest;
